import React from "react";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import "../../styles.css";

import DefaultText from "../../../../../components/Accessibility/DefaultText";
import { getBenef } from "../../../../../Store/storages/BeneficiarioStorage";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { capitalize } from "../../../../../utils/Capitalize";
import {
  GestaoDeCronicosStepsEnum,
  ITermResp,
} from "../../../../../interfaces/enum/GestaoDeCronicosEnum";
import { Detalhes } from "../Detalhes";
import { QuestionarioIMC } from "../QuestionarioIMC";
import { ResultadoIMC } from "../ResultadoIMC";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { QuestionarioQuestoes } from "../QuestionarioQuestoes";
import { AgendarConsulta } from "../AgendarConsulta";
import { ConfirmeSeusDados } from "../AgendarConsulta/components/ConfirmeSeusDados";
import ModalTerms from "../../../../../components/ModalTerms";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import ModalFeedBack from "../../../../../components/ModalFeedBack";
import LoadingApp from "../../../../../components/LoadingApp";
import VoltarButton from "../../../../../components/Accessibility/VoltarButton";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

export const CaptacaoInicio = () => {
  const navigate = useNavigate();
  const benef = getBenef();
  const { textStyleAccessibility, contrastBorderAccessibility } =
    useAccessibility();
  const {
    loading,
    texts,
    images,
    open,
    termResp,
    currentStep,
    openErrorModal,
    closeErrorModal,
    handleChangeStep,
    handleBackButtonClick,
    handleTermsOfUse,
    setOpen,
    getTermRespAccept,
    getDetails,
  } = useGestaoDeCronicosCaptacao();

  return (
    <div
      style={{
        ...textStyleAccessibility,
        ...contrastBorderAccessibility,
      }}
      className="gestao-de-cronicos-container"
    >
      <LoadingApp showLoading={loading} />
      {!loading && currentStep === GestaoDeCronicosStepsEnum.inicio && (
        <div className="content-container">
          <h1
            className="gestao-de-cronicos-title"
            style={textStyleAccessibility}
          >
            Gestão de Crônicos - Como está sua saúde?
          </h1>
          {images.map((img, i) => (
            <img
              key={i}
              className="img-home"
              src={img.replace(
                "data:image/svg;base64,",
                "data:image/svg+xml;base64,"
              )}
              alt="Gestão de Crônicos"
            />
          ))}
          <p className="text-title" style={textStyleAccessibility}>
            Olá, {capitalize(benef?.nome ?? "")}{" "}
            {capitalize(benef?.sobrenome ?? "")}!
          </p>
          {texts.map((t, i) => (
            <DefaultText key={i} text={t} />
          ))}
          <div className="button-container">
            <div className="button-config">
              <DefaultButton
                className="button-questionnaire"
                onClick={() => {
                  getTermRespAccept();
                }}
              >
                <Typography style={{ color: "#fff" }}>
                  INICIAR QUESTIONÁRIO
                </Typography>
              </DefaultButton>
              <DefaultButton
                className="button-questionnaire"
                variant="outlined"
                style={{ background: "#fff" }}
                onClick={() => {
                  getDetails();
                  handleChangeStep(GestaoDeCronicosStepsEnum.detalhes);
                }}
              >
                <Typography style={{ color: "#00995D" }}>
                  MAIS DETALHES
                </Typography>
              </DefaultButton>
            </div>
          </div>
          <VoltarButton onClick={() => navigate("/notificacoes/notificacao")} />
          <ModalTerms
            open={open}
            handleTermsOfUse={handleTermsOfUse}
            terms={
              {
                descricao: termResp?.descricao ?? "",
                abrevSist: termResp?.abrevSist ?? "",
                idTermoResponsabilidade:
                  termResp?.idTermoResponsabilidade ?? "",
                codigo: termResp?.codigo ?? "",
              } as ITermResp
            }
            closeTermsOfUse={() => setOpen(false)}
          />
        </div>
      )}
      {!loading &&
        currentStep !== GestaoDeCronicosStepsEnum.inicio &&
        currentStep !== GestaoDeCronicosStepsEnum.detalhes &&
        currentStep !== GestaoDeCronicosStepsEnum.agendarConsulta &&
        currentStep !==
          GestaoDeCronicosStepsEnum.agendarConsultaConfirmeSeusDados && (
          <h1
            className="gestao-de-cronicos-title"
            style={textStyleAccessibility}
          >
            Questionário
          </h1>
        )}
      {!loading && currentStep === GestaoDeCronicosStepsEnum.detalhes && (
        <>
          <Detalhes />
          <div className="button-container">
            <div className="button-config">
              <DefaultButton
                className="button-questionnaire"
                onClick={() => {
                  getTermRespAccept();
                }}
              >
                <Typography style={{ color: "#fff" }}>
                  INICIAR QUESTIONÁRIO
                </Typography>
              </DefaultButton>
            </div>
            <ModalTerms
              open={open}
              handleTermsOfUse={handleTermsOfUse}
              terms={
                {
                  descricao: termResp?.descricao ?? "",
                  abrevSist: termResp?.abrevSist ?? "",
                  idTermoResponsabilidade:
                    termResp?.idTermoResponsabilidade ?? "",
                  codigo: termResp?.codigo ?? "",
                } as ITermResp
              }
              closeTermsOfUse={() => setOpen(false)}
            />
          </div>
        </>
      )}

      {!loading &&
        currentStep === GestaoDeCronicosStepsEnum.questionarioIMC && (
          <QuestionarioIMC />
        )}
      {!loading && currentStep === GestaoDeCronicosStepsEnum.resultadoIMC && (
        <ResultadoIMC />
      )}
      {!loading &&
        currentStep === GestaoDeCronicosStepsEnum.questionarioQuestoes && (
          <QuestionarioQuestoes />
        )}
      {!loading &&
        currentStep === GestaoDeCronicosStepsEnum.agendarConsulta && (
          <AgendarConsulta />
        )}
      {!loading &&
        currentStep ===
          GestaoDeCronicosStepsEnum.agendarConsultaConfirmeSeusDados && (
          <ConfirmeSeusDados />
        )}
      {!loading && currentStep !== GestaoDeCronicosStepsEnum.inicio && (
        <button
          className="what-is-it-back-button"
          style={{
            ...textStyleAccessibility,
            display: "flex",
            alignItems: "center",
            marginTop: "30px",
          }}
          onClick={handleBackButtonClick}
        >
          <FontAwesomeIcon
            style={textStyleAccessibility}
            icon={faChevronLeft}
          />
          &nbsp;&nbsp;<u>Voltar</u>
        </button>
      )}
      <ModalFeedBack
        showModal={openErrorModal}
        handleShowModal={closeErrorModal}
        handleButtonModal={closeErrorModal}
        icon="error"
        title="Erro"
        subTitle="Ocorreu um erro. Tente novamente em instantes."
        textButton="Fechar"
        showButtonModal
      />
    </div>
  );
};
